import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveProjectUsers(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const users = await axios.get(`/autodesk/bim-360/account-admin/project-users/${data.projectId}/users`, config);
        return users.data;
      } catch (error) {
        throw error;
      }
    },
    async bulkMembersToProject(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const users = await axios.post(`/autodesk/bim-360/account-admin/project-users/${data.projectId}`, data.members, config);
        return users.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
